import {treeAspectMinorTabgroup, wikiTab} from 'uix/views/utils'

const isDomainNode = ({treeNode}) => treeNode.nodeType == 'domain'
export const config = {
  ...treeAspectMinorTabgroup,
  acl: 'g:admin,g:debug',
  tabGroup: 'config',
  tabs: {
    domain: {
      enabled: isDomainNode,
      default: true,
      parts: ['ShowConfig'],
    },
    frontend: {
      enabled: isDomainNode,
      parts: ['ShowFrontendConfig'],
    },
    edit: {
      tabGroupDefault: true,
      minorTabGroup: 'Editor',
      enabled: isDomainNode,
      parts: [
        {
          type: 'EditConfig',
          filters: ['getDatabaseConfigData'],
        },
      ],
    },
    history: {
      minorTabGroup: 'Editor',
      enabled: isDomainNode,
      parts: ['ConfigHistory'],
    },
    chain: {
      enabled: isDomainNode,
      parts: [
        {
          type: 'DomainConfigChain',
          filters: ['getConfigAndChain'],
        },
      ],
    },
    css: {
      enabled: isDomainNode,
      parts: ['EditCSS'],
    },
    mods: {
      enabled: isDomainNode,
      parts: ['EditModsElementOrder'],
    },
  },
}
